module.exports = __webpack_public_path__ + "static/img/4.d0d292f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/zh/4.png
// module id = fSLs
// module chunks = 0